export default __webpack_public_path__ + "img/lancia-logo.6d6c693e.png";